export default __webpack_public_path__ + "static/media/Icon-Jur-Dokumente.328c16ad.svg";